import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-extra-info-reminder',
  templateUrl: './extra-info-reminder.component.html',
  styleUrls: ['./extra-info-reminder.component.scss'],
})
export class ExtraInfoReminderComponent {
  @Input({ required: true }) extraOneTimeInfo!: string;

  constructor(
    private modalController: ModalController,
  ) { }

  async close(): Promise<void> {
    const topModal = await this.modalController.getTop();
    if (topModal) {
      await this.modalController.dismiss();
    }
  }
}
